import React, { useState, useEffect } from "react";
import { BsX } from "react-icons/bs";
import { useTranslation } from "react-i18next";
import { Modal } from "reactstrap";

const IntensiveAlertModal = ({ live_info, isAlertModalOpened, handleSelectedFunc }) => {
    const { t } = useTranslation();

    return (
        <Modal isOpen={isAlertModalOpened} centered backdrop={false}>
            <div className="card container-fluid">
                <div className="card-body">
                    <div className="title-area text-center dark-grey-text">
                        <span><b>{t("클래스_종료_불가_안내_문구_1", { ns: "live" })}</b></span>
                    </div>
                    {/* <div className="title-area text-center dark-grey-text">
                        <div className="text-area text-center">
                            <span className="hiclass-text area-70" title={live_info.liveName}>
                                <span className="small mb-2">[{t("클래스_이름", { ns: "live" })}]</span>&nbsp;
                                <b>{live_info.liveName}</b>
                            </span>
                        </div>
                    </div> */}
                    <div className="content-area dark-grey-text">
                        <div className="text-area text-center" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <span className="small mb-2">[{t("클래스_이름", { ns: "live" })}]</span>
                            <span className="hiclass-text area-70" title={live_info.liveName}>
                                <b>{live_info.liveName}</b>
                            </span>
                        </div>
                        <div className="d-flex flex-column text-center small mt-3">
                            <span>{t("클래스_종료_불가_안내_문구_2", { ns: "live" })}</span>
                            <span>{t("클래스_종료_불가_안내_문구_3", { ns: "live" })}</span>
                        </div>
                    </div>
                    <button type="button" className="btn btn-md green white-text py-1 px-2" onClick={() => handleSelectedFunc({ selectedFunc: "TOGGLE_INTENSIVE_ALERT" })}>{t("확인", { ns: "common" })}</button>
                </div>
            </div>
        </Modal>
    );
}
export default IntensiveAlertModal;